import { getChatUrl, NEW_CHAT_COUNTRIES } from '@law-connect/react-components';
import loadEnv from '../constants/env';

type ChatRedirectParams = {
  /** Chat path; defaults to `/chat`. */
  path?: string;
  /** Appended as `?ask=<message>`. */
  message?: string;
  /** Appended as `?newCase=true`. */
  newCase?: boolean;
  /**
   * Source-component id, appended as `?ref=<ref>` so the destination
   * client-portal can attribute the chat load. Kebab-case, `webapp-` prefixed
   * (e.g. `webapp-account-new-case`). Omitted when not provided.
   */
  ref?: string;
};

/**
 * For NEW_CHAT_COUNTRIES (en-au) build an absolute URL on the new chat domain
 * (WEBAPP_NEW_CHAT_URL) so the caller can do `window.location.href = ...` / use
 * it as an `href`. For every other language returns null, signalling the caller
 * to keep using in-app SPA navigation.
 */
export const getNewChatRedirect = (
  language: string | undefined,
  params: ChatRedirectParams = {},
): string | null => {
  if (!language || !NEW_CHAT_COUNTRIES.includes(language)) return null;
  return getChatUrl({ ...params, origin: loadEnv.NEW_CHAT_URL, language });
};
